
import {Component, Vue} from 'vue-property-decorator'
import FromUserInfo from '@/model/modules/FromUserInfo'
import FromUserService from '@/service/modules/FromUserService'

@Component
export default class FromUserEditor extends Vue {
  item: FromUserInfo = new FromUserInfo()
  showState: boolean = false
  savingState: boolean = false
  saveSuccessCallback: any

  showEditor(item: FromUserInfo, saveSuccessCallback: any) {
    this.item = JSON.parse(JSON.stringify(item))
    this.saveSuccessCallback = saveSuccessCallback
    this.showState = true
  }

  saveEditor() {
    this.savingState = true
    if (this.item.id === 0) {
      delete this.item.id
    }
    FromUserService.save(this.item)
      .then(() => {
        this.$alert('保存数据', '保存成功', {
          confirmButtonText: '确定'
        })
        this.savingState = false
        this.showState = false
        this.saveSuccessCallback()
      })
  }
}
